var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _circle, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharityRafiki(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.31 153.37a11.15 11.15 0 00-11.12-13 11 11 0 00-1.83.16 12.87 12.87 0 00-23.43 3.13 8.46 8.46 0 00-2.48-.37 8.36 8.36 0 00-8.36 8.36 8.55 8.55 0 00.19 1.76zM145 108.86a19 19 0 00.26-3 19.39 19.39 0 00-19.39-19.39 19.19 19.19 0 00-3.14.28 22.11 22.11 0 00-40.25 5.35 14.35 14.35 0 00-18.31 16.76z",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M0 382.4h500v.25H0zM416.78 398.49h33.12v.25h-33.12zM322.53 401.21h8.69v.25h-8.69zM396.59 389.21h19.19v.25h-19.19zM52.46 390.89h43.19v.25H52.46zM104.56 390.89h6.33v.25h-6.33zM131.47 395.11h93.68v.25h-93.68zM237 337.8H43.91a5.71 5.71 0 01-5.7-5.71V60.66a5.71 5.71 0 015.7-5.66H237a5.71 5.71 0 015.71 5.71v271.38a5.71 5.71 0 01-5.71 5.71zM43.91 55.2a5.46 5.46 0 00-5.45 5.46v271.43a5.46 5.46 0 005.45 5.46H237a5.47 5.47 0 005.46-5.46V60.66A5.47 5.47 0 00237 55.2zM453.31 337.8h-193.1a5.72 5.72 0 01-5.71-5.71V60.66a5.72 5.72 0 015.71-5.66h193.1a5.71 5.71 0 015.69 5.66v271.43a5.71 5.71 0 01-5.69 5.71zM260.21 55.2a5.47 5.47 0 00-5.46 5.46v271.43a5.47 5.47 0 005.46 5.46h193.1a5.47 5.47 0 005.46-5.46V60.66a5.47 5.47 0 00-5.46-5.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M37.91 353.46v-66.48h32.02V268.8h15.33v-53.43l19.8-19.8h40.2v57.25h55.15v11.31h38.99v-14.86h41.89v-11.2H314v-66.32h57.91v42.26h13.33v15.31h30.99v25.11h16.56l12.74 12.74v12.96h12.69v73.33H37.91z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M76.91 286.98h-6.43l-.55-.38v.38H37.91v66.48h39v-66.48zM239.96 254.11v10.02h-1.58l-1.68 10.72 4.75 78.61h52.83V249.27h-53.57l-.75 4.84zM362.95 229.32v124.14h95.82v-73.33h-12.69v-12.96l-12.74-12.74h-16.56v-25.11h-53.83z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M427.61 261.17h5.79v5.79h-5.79zM417.38 261.17h5.79v5.79h-5.79zM427.61 271.96h5.79v5.79h-5.79zM417.38 271.96h5.79v5.79h-5.79zM395.99 233.99h5.79v5.79h-5.79zM385.76 233.99h5.79v5.79h-5.79zM64.4 296.35h5.79v5.79H64.4zM54.17 296.35h5.79v5.79h-5.79zM287.61 266.29v5.79h-5.79v-5.79zM287.61 256.06v5.79h-5.79v-5.79z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.06,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M388.9 366.94h54.63v45.18H388.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.3,
    d: "M388.9 366.94h54.63v45.18H388.9z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M360.03 366.94h42.34v45.18h-42.34z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.1,
    d: "M360.03 366.94h42.34v45.18h-42.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.3,
    d: "M375.21 366.94h11.98V381h-11.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.1,
    d: "M419.91 366.94h11.98V381h-11.98z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M420.56 393.53h-1.58a12.71 12.71 0 010-1.38c0-.72.55-2.11 1.55-1.48.31.19.67-.25.36-.44a1.58 1.58 0 00-2.38 1.14 7.66 7.66 0 00-.1 2.14h-.91c-.36 0-.46.55-.09.56h1v2.64c0 .37.57.3.57-.06v-2.57h1.48c.37.02.47-.54.1-.55zM423.18 392.29a.25.25 0 00-.12 0c-2.59-.19-2.18 4.05.3 4a2.16 2.16 0 001.85-2.23 1.74 1.74 0 00-2.03-1.77zm.39 3.39c-1.87.49-2.47-3-.55-2.79a.34.34 0 00.18 0c1.8-.27 1.8 2.41.37 2.79zM429.36 393.34c-.77-2.5-4.65-.45-3.54 1.83a2.18 2.18 0 002.76.81 1.74 1.74 0 00.84-2.56zm-3.09 1.43c-.53-1.52 2-3 2.56-1.2a.22.22 0 00.11.15c.98 1.75-2.13 2.63-2.67 1.05zM433.7 396.1c-.17-2.3-.33-4.6-.5-6.89 0-.37-.59-.3-.57.06l.21 2.9a2.09 2.09 0 00-2.73 1.86c-.08 1.55 1.72 2.08 3 1.91v.22c.05.36.62.3.59-.06zm-3-1.82a1.54 1.54 0 012-1.57.33.33 0 00.17 0c.07.88.13 1.76.2 2.65-.87.12-2.24-.06-2.39-1.08z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.02,
    y: 95.51,
    width: 164.95,
    height: 311.54,
    rx: 15,
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M110.69 116.28h143.62v250.56H110.69z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.3,
    d: "M110.69 342h143.62v24.83H110.69z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.31 219.38c-36.51 36.31-104.12 104.23-143.62 144v3.5h80.25l63.37-63.36zM110.69 242.28l126-126h-58.92c-15.6 15.48-42.25 42.18-67.08 67.1zM110.69 294.95l143.62-143.62V120.6L110.69 264.21v30.74z",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.2,
    d: "M110.69 116.28h143.62v11.3H110.69z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 384.04,
    r: 9.79,
    transform: "rotate(-9.22 182.428 383.939)",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.6,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.6,
    d: "M128.39 124.52h-2.17v-2.9h2.17zM124.85 124.52h-2.17v-3.86h2.17zM121.31 124.52h-2.17v-4.83h2.17zM117.77 124.52h-2.17v-5.8h2.17z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6,
    d: "M237.78 120.56h1.29v2.9h-1.29zM250.23 124.52h-10.27v-5.01h10.27z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.65 266c-3.29-3-7.15 1-7.15 1s-3.85-4-7.15-1.05c-4.7 4.21 2.13 11.74 7.15 13.25 5.02-1.47 11.85-9 7.15-13.2z",
    fill: "#fff",
    opacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.63 287h-82.26a9.38 9.38 0 000 18.76h82.26a9.38 9.38 0 000-18.76z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.37 301.37v-9.95H159a5.34 5.34 0 012.12.4 4.38 4.38 0 011.52 1.06 4.42 4.42 0 01.91 1.58 6.23 6.23 0 010 4 4.36 4.36 0 01-1 1.57 4.59 4.59 0 01-1.53 1 5.37 5.37 0 01-2 .36zm6.51-5a4.55 4.55 0 00-.19-1.31 2.91 2.91 0 00-.57-1 2.53 2.53 0 00-.93-.67 3 3 0 00-1.24-.24h-1.67v6.55H159a3 3 0 001.26-.25 2.62 2.62 0 00.91-.69 3.13 3.13 0 00.57-1.05 4.49 4.49 0 00.14-1.33zM169.51 301.44a4.51 4.51 0 01-2-.43 4.74 4.74 0 01-1.51-1.14 5.26 5.26 0 01-1.33-3.47 5 5 0 01.37-1.91 5.16 5.16 0 011-1.61 4.78 4.78 0 011.54-1.11 4.43 4.43 0 011.93-.41 4.23 4.23 0 011.95.44A4.88 4.88 0 01173 293a5.26 5.26 0 011 1.63 4.93 4.93 0 01.35 1.84 5.06 5.06 0 01-.36 1.9 5.2 5.2 0 01-1 1.6 4.61 4.61 0 01-1.53 1.1 4.43 4.43 0 01-1.95.37zm-2.86-5a4 4 0 00.2 1.24 3.52 3.52 0 00.56 1.07 3.08 3.08 0 00.9.74 2.67 2.67 0 001.22.28 2.6 2.6 0 001.23-.29 2.85 2.85 0 00.9-.76 3.5 3.5 0 00.55-1.07 3.87 3.87 0 00.19-1.21 4 4 0 00-.2-1.25 3.33 3.33 0 00-.57-1.07 2.68 2.68 0 00-.9-.73 2.84 2.84 0 00-2.44 0 2.89 2.89 0 00-.9.76 3.56 3.56 0 00-.55 1.06 4.2 4.2 0 00-.19 1.19zM177.72 295v6.37h-1.92v-9.95h1.49l5.13 6.53v-6.51h1.92v9.93h-1.55zM189.2 291.42h1.69l3.75 9.95h-2l-.92-2.48h-3.44l-.9 2.48h-2zm2.21 6.11l-1.36-3.91-1.42 3.91zM202.12 293.12H199v8.25h-1.9v-8.25h-3.15v-1.7h8.2zM210.19 299.67v1.7h-6.85v-9.95h6.72v1.7h-4.8v2.39h4.15v1.57h-4.15v2.59z",
    fill: "#e0e0e0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    opacity: 0.3,
    d: "M264.98 184.39l-30.13 4.29 7.87 55.98 22.26-2.26v-58.01z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 183.89,
    cy: 198.96,
    r: 55.46,
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.7
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.78 165.05s11.33 16.76 17.69 17.44 31.24-20.72 31.24-20.72l4.22 3.65s-23.67 26-33.55 27.52-28.66-18.06-28.66-18.06z",
    fill: "#e4897b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.08 166.3s4-3.92 9.5 2.89 7.76 8.2 7.76 8.2l-14 13.67s-8.23-21.12-3.26-24.76z",
    fill: "#92e3a9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M250.74 160.22s.49-6.29 1.95-6.69.94 4.25.94 4.25 7.7-4.7 9.25-4.28 1.3 3.46 1 4.28c-2.35 7-10.75 9.9-10.75 9.9l-3.39-3.2z",
    fill: "#e4897b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193 148.41s7.73 12.88 5.36 21-14.56.82-14.56.82l.15-16z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M172.27 126.21s-11.43 5.79-6.94 26.16c7.52 34.15 18.62 20 18.62 20s-.49-13.46-5-20-3.57-15.87-3.57-15.87z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M205.42 216.43l-34.27 3a121.42 121.42 0 00-3.65-25.17c-.82-3.28-1.84-6.95-3.16-11.18-.71-2.27-1.49-4.7-2.36-7.31-.65-2-1.36-4.09-2.14-6.32a102.37 102.37 0 0114.23-3.45 107.1 107.1 0 0115.38-1.62c6.67-.06 14.33.69 14.33.69s1.09.26 1.78 7.33c.62 6.6 1.23 19.89-.14 44.03z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.42 216.43l-34.27 3a121.42 121.42 0 00-3.65-25.17c-.82-3.28-1.84-6.95-3.16-11.18-.71-2.27-1.49-4.7-2.36-7.31-.65-2-1.36-4.09-2.14-6.32a102.37 102.37 0 0114.23-3.45 107.1 107.1 0 0115.38-1.62c6.67-.06 14.33.69 14.33.69s1.09.26 1.78 7.33c.62 6.6 1.23 19.89-.14 44.03z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 216.82c5.49-2.14 23.59-11 23.59-11l-24 5.42c.11 1.82.26 3.66.41 5.58z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186.63 171.92c-8.45-1.08-11-4.68-11-4.68 5.36-5.06.91-13.82.91-13.82l10.16 1.9a29.91 29.91 0 00-.39 4.28c-.08 6.17 2.71 6.23 2.71 6.23 1.79 3.34-2.39 6.09-2.39 6.09z",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.71 155.32a29.91 29.91 0 00-.39 4.28c-6.87 0-9.77-6.18-9.77-6.18z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.15 126.86c8.84-.49 10.84 3.75 12 12.82 1.44 11.34-.6 19.93-11.78 18.11-12.27-2-15.71-21.43-8.33-28.86 1.73-1.76 5.3-1.93 8.11-2.07z",
    fill: "#e4897b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M188.44 140.83a18.64 18.64 0 002.77 3.52 2.42 2.42 0 01-2.27 1.13z",
    fill: "#de5753"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.09 139.81a1.93 1.93 0 00.86-.87l-1.53.74a1.25 1.25 0 00-.6 1.31c.05.73.49 1.28 1 1.25s.83-.66.78-1.38a1.53 1.53 0 00-.51-1.05zM191.67 139a1.93 1.93 0 00.86-.87l-1.52.74a1.28 1.28 0 00-.61 1.32c.06.73.5 1.28 1 1.24s.83-.65.77-1.38a1.45 1.45 0 00-.5-1.05z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.08 135.73a4.63 4.63 0 00-3.76 1.55M188.45 135.37a4.15 4.15 0 013.6-.23",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.707
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M167.81 168.17s9.92 8.05 19.15 7.92 12.48-10.51 12.48-10.51-14.32-4.24-31.63 2.59zM153.22 188.27s-3.12 18.4-2.75 23.64 8.29 5.4 12.75 4.87c5.13-.61 31.88-11.19 31.88-11.19l-1.24-5.29S172.92 206 164 207a2.75 2.75 0 01-3-3.14l2.07-13.66z",
    fill: "#e4897b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M159.84 169.41s5.47-1.21 6.53 7.48a31.72 31.72 0 01-2 15.53l-13.86-2.5s3.19-20.06 9.33-20.51z",
    fill: "#92e3a9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M200.69 195a1.71 1.71 0 00-1.14-.23c-1.64.42-6.62 5.35-6.91 6l1.28 4.67s2.62 1.4 3.89 1 7.71-5.14 7.72-6.28a.81.81 0 000-.19c.23-.17.42-.31.55-.39 1.09-.68-2.94-3.69-5.39-4.58z",
    fill: "#e4897b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M181.63 126.89s1.13 11.08-8.11 11.48-1.52-9.93-1.52-9.93z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M179.65 123.47c-15.19.48-13.93 22.7-5.72 28.9 0 0-4-5.38-1.68-10.06 0 0 3-7.24 2-12.81a24.48 24.48 0 017.39-1.91c1.71 2.08 6 8.4 11.62 8.27a20.68 20.68 0 01.75 3s.85-15.86-14.36-15.39zM190.74 149.74a6.17 6.17 0 01-5.6.1.21.21 0 01-.08-.29.19.19 0 01.27-.08 5.77 5.77 0 005.2-.11.21.21 0 01.28.08.2.2 0 01-.08.27z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M173.8 144.1a3.88 3.88 0 00-4.37-3.31c-2.72.44-3.72 6.14 3.17 7.12.98.14 1.48-.85 1.2-3.81z",
    fill: "#e4897b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.77 184.51l9.2-1.3s3 9.81-2.46 10.86c-5.97 1.16-6.74-9.56-6.74-9.56z",
    fill: "#92e3a9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M207.43 237.37c-.46-4.54-1.18-10.72-2.1-15.58l.09-5.36-34.27 3-.31 5c-.8 1.48-4.3 8.81-5.88 26.74a55.5 55.5 0 0044-2.66z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M294.34 220.82l-17.43 4.42a6.66 6.66 0 00-4.51-.92c-2.47.46-8.65 5.51-8.41 6.25s7.69 4.17 8.76 3.89c3.84-1 7.8-5.47 7.8-5.47l15.58-3.21zM338 158.14c-3.54 3.77-12.92 3.45-12.92 3.45s-3.09.27-3.86-2.35c3.39-.84 3.91-3.28 4.44-5.39a10.07 10.07 0 000-3.95 18.38 18.38 0 00-.46-2.18l10.89-9.47c-1.01 5.75-2.09 16.09 1.91 19.89z",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.91 143.9c.09 7-5.46 9.34-8.22 9.95a10.07 10.07 0 000-3.95z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M334.81 145.44a9.82 9.82 0 01-10.95 4.69 10.89 10.89 0 01-6.63-4.58 9 9 0 01-.6-1c-3.35-6.38-5.16-17.85 1.48-22.73a10.65 10.65 0 0116.89 6.73c1.44 7.65 2.66 12.08-.19 16.89z",
    fill: "#e4897b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M323.63 134.05a1 1 0 01-.45 1.3c-.4.1-.85-.32-1-.93s.05-1.2.45-1.3.84.31 1 .93zM316.88 135.47c.2.6-.05 1.2-.44 1.3s-.86-.32-1-.93.05-1.2.45-1.3.84.35.99.93z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M319.31 135.66a21.44 21.44 0 01-1.41 5.86c1 .4 2.4-.23 3.35-.75z",
    fill: "#de5753"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M325.63 130.77a.38.38 0 01-.38-.06 3 3 0 00-2.62-.62.37.37 0 11-.23-.7 3.75 3.75 0 013.31.74.37.37 0 01.07.52.58.58 0 01-.15.12zM322.68 143.8a5.79 5.79 0 004.41-2.88.19.19 0 00-.09-.26.18.18 0 00-.25.08 5.46 5.46 0 01-4.11 2.65.19.19 0 00-.18.21.19.19 0 00.21.17zM313.48 133.68a.31.31 0 01-.21.07.36.36 0 01-.29-.43 3.72 3.72 0 012.08-2.69.37.37 0 01.48.21.37.37 0 01-.21.48 3 3 0 00-1.61 2.16.39.39 0 01-.24.2z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M339.84 133.9a7.47 7.47 0 01-3.2 4.68c-2.19 1.4-4-.37-4.08-2.83 0-2.19 1.08-5.63 3.59-6s4.15 1.79 3.69 4.15z",
    fill: "#e4897b"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M305.4 164.08a29.89 29.89 0 00-8 13c-1.88 6-3.64 20.13-4.5 27.8a6.94 6.94 0 01-5.71 6l-21.06 3.67 1.68 10.71 26.68-2.57a13.33 13.33 0 0011.8-10.69c1.63-8.25 3.81-20.21 4.8-29.68 1.68-16.09-.09-19.9-5.69-18.24z",
    fill: "#92e3a9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M305.4 164.08a29.89 29.89 0 00-8 13c-1.88 6-3.64 20.13-4.5 27.8a6.94 6.94 0 01-5.71 6l-21.06 3.67 1.68 10.71 26.68-2.57a13.33 13.33 0 0011.8-10.69c1.63-8.25 3.81-20.21 4.8-29.68 1.68-16.09-.09-19.9-5.69-18.24z",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4897b",
    d: "M290.61 402.1l-7.92-1.95 4.51-16.97 7.92 1.95-4.51 16.97z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M282.77 397.41l9 3.24a.68.68 0 01.44.74l-.91 7.11a1.17 1.17 0 01-1.31 1 1 1 0 01-.25-.07c-2.89-1.09-4.94-2-8.59-3.35-2.25-.82-9.12-3-12.22-4.15s-2.4-4.33-1-4.16c6.15.82 11.06.65 13.47-.33a1.89 1.89 0 011.37-.03z",
    fill: "#2e353a"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M279.85 397.82a2.28 2.28 0 01-1.28-.89 1.08 1.08 0 010-1.07.56.56 0 01.48-.38c1-.13 2.83 2.2 3 2.47a.16.16 0 010 .2.17.17 0 01-.18.1 9.5 9.5 0 01-2.02-.43zm-.55-1.93a.48.48 0 00-.24 0s-.13 0-.19.16a.79.79 0 000 .72 3.86 3.86 0 002.59 1.08 7.71 7.71 0 00-2.16-1.96z",
    fill: "#92e3a9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M281.84 398.24h-.09c-.61-.69-1.5-2.85-1.07-3.57a.61.61 0 01.73-.26 1 1 0 01.67.49c.6 1 0 3.2 0 3.31a.17.17 0 01-.14.12.16.16 0 01-.1-.09zm-.41-3.53h-.08c-.23-.08-.29.05-.32.09-.27.45.23 2 .78 2.87a4.37 4.37 0 000-2.63.63.63 0 00-.38-.33z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.2,
    d: "M295.12 385.13l-7.92-1.95-2.32 8.76 7.92 1.94 2.32-8.75z"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4897b",
    d: "M343.05 402.02l-8.1.96-1.75-17.47 8.1-.96 1.75 17.47z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M334.06 400.39l9.55-.13a.7.7 0 01.68.54l1.64 7a1.17 1.17 0 01-.88 1.39 1.09 1.09 0 01-.26 0c-3.09 0-5.34-.17-9.22-.12-2.39 0-9.59.37-12.89.42s-3.78-3.22-2.43-3.53c6-1.4 10.58-3.29 12.5-5.06a1.86 1.86 0 011.31-.51z",
    fill: "#2e353a"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M331.48 401.8a2.33 2.33 0 01-1.52-.38 1.09 1.09 0 01-.4-1 .56.56 0 01.31-.53c.87-.46 3.43 1.07 3.71 1.24a.17.17 0 01.09.18.18.18 0 01-.14.16 8.93 8.93 0 01-2.05.33zm-1.19-1.61a.39.39 0 00-.24.05c-.05 0-.11.07-.12.22a.78.78 0 00.26.67 3.82 3.82 0 002.8.1 7.54 7.54 0 00-2.7-1.04z",
    fill: "#92e3a9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M333.48 401.5h-.09c-.81-.43-2.4-2.14-2.25-3a.6.6 0 01.59-.5 1 1 0 01.79.23c.92.73 1.14 3 1.15 3.09a.19.19 0 01-.09.17zm-1.62-3.17h-.09c-.24 0-.26.14-.26.19-.1.51.92 1.81 1.74 2.41a4.4 4.4 0 00-1-2.45.57.57 0 00-.39-.15z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.2,
    d: "M341.3 384.55l-8.1.96.91 9.01 8.1-.96-.91-9.01z"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M305.38 242.36S285 342 284.3 380.26l13.58 6.07s11.06-43.23 14.65-67.52c0 0 9.52-19.29 12.08-35 0 0-.53 69 6.62 105.41l12.74-1s12.85-129.44 10.53-150.16z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.38 242.36S285 342 284.3 380.26l13.58 6.07s11.06-43.23 14.65-67.52c0 0 9.52-19.29 12.08-35 0 0-.53 69 6.62 105.41l12.74-1s12.85-129.44 10.53-150.16z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4 258.66s-1.51 23.69.64 32.39c.65-2.45 1.19-4.89 1.57-7.25z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M329.61 392.11l17.49-2.6-.54-4.84-18.18 2.38 1.23 5.06zM282 383.99l16.89 5.2 1.61-4.59-17.43-5.71-1.07 5.1zM305.4 164.08s2.16-4.27 21.14-5.37 27.46 1.71 27.46 1.71-1.72 40.18.48 77.65c0 0-31.74 11.31-49.12 4.29.02 0-13-48.53.04-78.28z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M333.34 158.47c-2.1 0-4.36.1-6.8.24-1.47.09-2.82.19-4.09.31 0 0 1.62 3.07 4.09 3.07a8.15 8.15 0 006.8-3.62z",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M353.51 210.68l-28.9 14.61s18.22.56 29.11-5.35q-.13-4.69-.21-9.26z",
    opacity: 0.3
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M326.17 169.96l10.27 45.69-2.28 5.91-7.99-51.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M272.166 179.433l54.084-8.195 7.831 51.688-54.084 8.195z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.1,
    d: "M272.166 179.433l54.084-8.195 7.831 51.688-54.084 8.195z"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M243.651 182.723l41.842-6.477 7.987 51.595-41.841 6.478z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.3,
    d: "M243.651 182.723l41.842-6.477 7.987 51.595-41.841 6.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.3,
    d: "M258.66 180.394l11.84-1.833 2.15 13.894-11.838 1.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.1,
    d: "M302.836 173.567l11.839-1.833 2.15 13.894-11.838 1.833z"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.2,
    d: "M276.27 219.533l12.935-2.003 1.22 7.877-12.937 2.002z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M309.41 224.88l-1.33-1.76-4.29.92a6.07 6.07 0 00-.26 2.26l6-.92z",
    fill: "#2e353a",
    opacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M302 203.22c-1 .34-2.4.32-2.54-1-.11-1.1 1.19-2 2.18-1.82a.29.29 0 00.1-.58 2.52 2.52 0 00-2.87 2.46c.17 1.74 2 2 3.35 1.5.39-.13.18-.69-.22-.56zM303 197.72c-.09-.37-.68-.31-.6.06q.65 2.86 1.27 5.71c.08.37.67.32.59-.06zM306.55 198.84a.18.18 0 00-.1.07c-2.67.51-1.1 4.68 1.38 3.91a2.25 2.25 0 001.25-2.74 1.81 1.81 0 00-2.53-1.24zm1.32 3.31c-1.75 1-3.3-2.32-1.31-2.66a.27.27 0 00.16-.08c1.78-.74 2.51 1.96 1.15 2.74zM311.54 197.26l-1.09.19-.18-1.18c-.06-.38-.65-.32-.59.06s.12.81.19 1.22l-1.08.18c-.37.07-.32.66.06.6l1.11-.19.66 4.29c.06.37.65.31.59-.07-.22-1.44-.45-2.88-.67-4.32l1.07-.19c.39-.06.31-.66-.07-.59zM315.72 198.05a2.2 2.2 0 00-2.38.09q-.21-1.17-.45-2.34c-.08-.37-.67-.31-.59.07q.61 3 1 6c.06.38.65.32.59-.06-.14-1-.3-2-.47-3a1.58 1.58 0 012.32.1 5.7 5.7 0 01.55 2.44.3.3 0 00.59-.06c-.06-1.08-.1-2.67-1.16-3.24zM318.24 196.91a1.92 1.92 0 00-.67 2.8 2.17 2.17 0 003.05.94c.34-.17.13-.73-.21-.56a1.49 1.49 0 01-1.87-.11 2.33 2.33 0 01-.48-.62c.88.07 2.49-.11 2.53-1.07.05-1.23-1.36-1.77-2.35-1.38zm1.68 1.47c-.09.14-.5.23-.66.28a2.77 2.77 0 01-1.4.08 1.23 1.23 0 01.2-.93 1.12 1.12 0 011.23-.36c.29.07.91.55.63.93zM325 198.07a1.47 1.47 0 00-1.69-.67c-.48.1-1.64.58-1.38-.37.16-.63 1-.87 1.59-.82.38 0 .48-.55.09-.59-1-.09-2.93.81-2.31 2.12.29.61 1 .54 1.58.4a2.54 2.54 0 011-.19.68.68 0 01.47 1.12c-.42.55-1.24.45-1.84.35a.3.3 0 00-.1.59 2.63 2.63 0 002.22-.37 1.39 1.39 0 00.37-1.57z",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M334.23 214.58l-17.47 4.26a6.7 6.7 0 00-4.51-1c-2.46.44-8.69 5.43-8.46 6.17s6 5.26 7.07 4.93 7.8-5.09 7.8-5.09l16.64-1.39z",
    fill: "#e4897b"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M352.89 160.36s-7.34 1.95-6.3 15.57c.46 5.92.69 12.24.81 17.5a18.55 18.55 0 01-10.3 17l-14.34 5.86 1.85 9s20.84-1.91 28.17-7.77 9.88-18.37 8.69-28.74c-1.66-14.4-1.11-29-8.58-28.42z",
    fill: "#92e3a9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M352.89 160.36s-7.34 1.95-6.3 15.57c.46 5.92.69 12.24.81 17.5a18.55 18.55 0 01-10.3 17l-14.34 5.86 1.85 9s20.84-1.91 28.17-7.77 9.88-18.37 8.69-28.74c-1.66-14.4-1.11-29-8.58-28.42z",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M324.12 214.01l1.22 12.52-3.37.32-1.79-11.72 3.94-1.12z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6,
    d: "M324.12 214.01l1.22 12.52-3.37.32-1.79-11.72 3.94-1.12z"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M330.122 180.665l11.623-1.04.166 1.853-11.624 1.04z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M326.54 158.71l3.76 5 7.93-5.23V158a2.66 2.66 0 00-1-2.2 2.74 2.74 0 00-2.55-.17zM321.25 159.11l.93-1.54c1.17-1.38 2.1-.67 2.1-.67l2.26 1.81-3.3 5z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.54 158.71l3.76 5 7.93-5.23V158a2.66 2.66 0 00-1-2.2 2.74 2.74 0 00-2.55-.17zM321.25 159.11l.93-1.54c1.17-1.38 2.1-.67 2.1-.67l2.26 1.81-3.3 5z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M339.64 133.7c.53-3.42-1.84-3.89-3.4-3.48s-3.25 2.89-3.25 2.89c-1.52-2.46-2.38-8.69-2.38-8.69a14.26 14.26 0 01-12.71.54 10.11 10.11 0 01-4.13 5.07s-2.82-1.29-1.25-7.77c1.78-7.37 12.85-14.5 24-7.15s4.4 21 4.4 21-2.53 4.47-4.77 6.15a14.13 14.13 0 000-4 6.15 6.15 0 003.49-4.56z",
    fill: "#2e353a"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M316.58 123.13a11.59 11.59 0 002.22 2.08 12.8 12.8 0 002.72 1.48 11.34 11.34 0 003 .73 12.87 12.87 0 003.16-.09 13 13 0 01-3.17.34 11.55 11.55 0 01-3.19-.51 12.56 12.56 0 01-3-1.33 12.34 12.34 0 01-2.59-2.07z",
    fill: "#2e353a"
  }))), /*#__PURE__*/React.createElement("g", null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M445.17 179.64c-8.1-7.24-17.56 2.58-17.56 2.58s-9.47-9.82-17.56-2.58c-11.54 10.33 5.24 28.83 17.56 32.53 12.32-3.7 29.1-22.17 17.56-32.53z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M445.17 179.64c-8.1-7.24-17.56 2.58-17.56 2.58s-9.47-9.82-17.56-2.58c-11.54 10.33 5.24 28.83 17.56 32.53 12.32-3.7 29.1-22.17 17.56-32.53z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M281.67 83.34c-8.1-7.24-17.56 2.58-17.56 2.58s-9.47-9.82-17.56-2.58c-11.54 10.32 5.24 28.82 17.56 32.53 12.32-3.71 29.1-22.21 17.56-32.53z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.67 83.34c-8.1-7.24-17.56 2.58-17.56 2.58s-9.47-9.82-17.56-2.58c-11.54 10.32 5.24 28.82 17.56 32.53 12.32-3.71 29.1-22.21 17.56-32.53z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M376.84 113.4c-3.31-3-7.18 1.06-7.18 1.06s-3.86-4-7.17-1.06c-4.72 4.22 2.14 11.78 7.17 13.3 5.04-1.52 11.89-9.08 7.18-13.3z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.84 113.4c-3.31-3-7.18 1.06-7.18 1.06s-3.86-4-7.17-1.06c-4.72 4.22 2.14 11.78 7.17 13.3 5.04-1.52 11.89-9.08 7.18-13.3z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M74.47 192.86c-3.31-3-7.17 1.06-7.17 1.06s-3.87-4-7.18-1.06c-4.71 4.22 2.14 11.78 7.18 13.29 5.03-1.51 11.89-9.07 7.17-13.29z",
    fill: "#92e3a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.47 192.86c-3.31-3-7.17 1.06-7.17 1.06s-3.87-4-7.18-1.06c-4.71 4.22 2.14 11.78 7.18 13.29 5.03-1.51 11.89-9.07 7.17-13.29z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.6
  })));
}
export default "/_next/static/media/Charity-rafiki.29e032542cd599b77b63ac9ae67bc10a.svg";
export { SvgCharityRafiki as ReactComponent };